import { render, staticRenderFns } from "./text-tip.vue?vue&type=template&id=4ca32a51&scoped=true&"
import script from "./text-tip.vue?vue&type=script&lang=js&"
export * from "./text-tip.vue?vue&type=script&lang=js&"
import style0 from "./text-tip.vue?vue&type=style&index=0&id=4ca32a51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca32a51",
  null
  
)

export default component.exports